import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import IconDownSide from '../svg/IconDownSide';
import { Tokens } from '../../constant';

const Breadcrumbs = () => {
    const role = localStorage.getItem(Tokens.ADMIN_ROLE)
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);
    let breadcrumbPath = role === "user" ? "" : "/admin";

    const userBreadcrumbPath = () => {
        return pathnames.length >= 2 ? pathnames.map((name, index) => {
            breadcrumbPath += `/${name}`;
            const isLast = index === pathnames.length - 1;
            const isFirst = index === 0;
            return isLast ? (
                <span key={breadcrumbPath} className='text-xs text-textV2 font-500 capitalize'>{name}</span>
            ) : isFirst ? (
                <span key={breadcrumbPath} className='flex items-center gap-1'> <Link to={breadcrumbPath === '/portfolio' ? '/' : breadcrumbPath === '/allocation' ? '/allocation' : '#'} className='text-xs text-themeV2 font-500 flex items-center gap-1 capitalize'>{name}</Link> <span><IconDownSide className="text-textV2 w-4 h44 -rotate-90" /></span></span>
            ) : (
                <span key={breadcrumbPath} className='flex items-center gap-1'> <Link to={breadcrumbPath} className='text-xs text-themeV2 font-500 flex items-center gap-1 capitalize'>{name}</Link>   <span><IconDownSide className="text-textV2 w-4 h44 -rotate-90" /></span></span>

            );
        }) : ''
    }


    const adminBreadcrumbPath = () => {
        return pathnames.length >= 3 ? pathnames.toSpliced(0, 1).map((name, index) => {
            breadcrumbPath += `/${name}`;


            const isLast = index === pathnames.toSpliced(0, 1).length - 1;
            const isFirst = index === 0;

            return isLast ? (
                <span key={breadcrumbPath} className='text-xs text-textV2 font-500 capitalize'>{name}</span>
            ) : isFirst ? (
                <span key={breadcrumbPath} className='flex items-center gap-1'> <Link to={breadcrumbPath === '/portfolio' ? '/' : breadcrumbPath === '/allocation' ? '/allocation' : '#'} className='text-xs text-themeV2 font-500 flex items-center gap-1 capitalize'>{name}</Link> <span><IconDownSide className="text-textV2 w-4 h44 -rotate-90" /></span></span>
            ) : (
                <span key={breadcrumbPath} className='flex items-center gap-1'> <Link to={breadcrumbPath} className='text-xs text-themeV2 font-500 flex items-center gap-1 capitalize' >{name}</Link>   <span><IconDownSide className="text-textV2 w-4 h44 -rotate-90" /></span></span>
            );
        }) : ''
    }
    // console.log(breadcrumbPath)

    return (
        <div className='breadcrunbs flex items-center gap-1'>
            {role === 'user' ? userBreadcrumbPath() : adminBreadcrumbPath()}
        </div>
    )
}

export default Breadcrumbs